import React from 'react';
import { CommonIconProps } from './Icon';

const GenericPayrollProviderIcon = ({
  color,
}: CommonIconProps): JSX.Element => (
  <>
    <g clipPath="url(#clip0_2_16276)">
      <path
        d="M116.347 140.888C116.347 160.755 132.452 176.861 152.32 176.861C172.187 176.861 188.293 160.755 188.293 140.888C188.293 121.02 172.187 104.915 152.32 104.915C132.462 104.937 116.369 121.03 116.347 140.888ZM152.32 143.161C146.35 143.194 141.292 138.773 140.528 132.852C139.764 126.933 143.535 121.371 149.318 119.889V116.848C149.318 115.471 150.433 114.355 151.811 114.355C153.188 114.355 154.304 115.471 154.304 116.848V119.738C159.96 120.695 164.089 125.613 164.053 131.351C164.053 132.712 162.95 133.815 161.589 133.815C160.229 133.815 159.126 132.712 159.126 131.351C159.121 127.585 156.066 124.536 152.3 124.54C148.534 124.544 145.485 127.601 145.491 131.366C145.495 135.131 148.551 138.18 152.317 138.175C158.423 138.21 163.494 142.895 164.01 148.98C164.526 155.064 160.316 160.537 154.304 161.6V164.571C154.304 165.948 153.188 167.064 151.811 167.064C150.433 167.064 149.318 165.948 149.318 164.571V161.447C144.108 160.071 140.467 155.374 140.432 149.986C140.432 148.593 141.562 147.464 142.954 147.464C144.347 147.464 145.477 148.593 145.477 149.986C145.485 153.468 148.109 156.388 151.57 156.768C151.698 156.747 151.829 156.737 151.96 156.736C152.147 156.736 152.334 156.758 152.517 156.8C156.257 156.708 159.224 153.623 159.17 149.883C159.116 146.142 156.059 143.144 152.32 143.161Z"
        fill={color}
      />
      <path
        d="M210.052 194.01C210.034 194.02 210.016 194.029 209.994 194.039L186.852 204.972C187.101 206.254 187.21 207.558 187.175 208.862C187.139 210.212 186.034 211.286 184.685 211.286C184.661 211.286 184.637 211.286 184.614 211.286L150.744 210.354C149.367 210.318 148.281 209.17 148.319 207.794C148.356 206.416 149.504 205.332 150.88 205.368L182.013 206.226C180.981 200.192 175.837 195.724 169.718 195.546L149.115 194.98C145.046 194.863 141.056 193.832 137.44 191.963L135.343 190.878C125.047 185.514 112.641 186.212 103.012 192.699L102.188 222.672L105.728 220.776C109.246 218.884 113.363 218.434 117.208 219.52L152.174 229.334C158.913 230.714 165.916 229.932 172.185 227.098L220.628 195.763C217.862 192.933 213.582 192.222 210.052 194.01Z"
        fill={color}
      />
      <path
        d="M79.4326 227.88L80.661 183.285L98.2706 183.771L97.0422 228.366L79.4326 227.88Z"
        fill={color}
      />
      <path
        d="M154.658 91.5598V64.493C154.658 63.1158 153.542 62 152.165 62C150.788 62 149.672 63.1158 149.672 64.493V91.5598C149.672 92.9372 150.788 94.0528 152.165 94.0528C153.542 94.0528 154.658 92.9372 154.658 91.5598Z"
        fill={color}
      />
      <path
        d="M176.027 91.5625V78.7415C176.027 77.3641 174.911 76.2485 173.534 76.2485C172.157 76.2485 171.041 77.3641 171.041 78.7415V91.5625C171.041 92.9399 172.157 94.0555 173.534 94.0555C174.911 94.0555 176.027 92.9399 176.027 91.5625Z"
        fill={color}
      />
      <path
        d="M133.289 91.5625V78.7415C133.289 77.3641 132.173 76.2485 130.796 76.2485C129.418 76.2485 128.303 77.3641 128.303 78.7415V91.5625C128.303 92.9399 129.418 94.0555 130.796 94.0555C132.173 94.0555 133.289 92.9399 133.289 91.5625Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_2_16276">
        <rect width="300" height="300" fill="white" />
      </clipPath>
    </defs>
  </>
);

export default GenericPayrollProviderIcon;

GenericPayrollProviderIcon.prototype.svgPropOverrides = {
  viewBox: '80 60 140 180',
};
